export default class SoundEffect {
  private audio: HTMLAudioElement;
  private ready = false;

  constructor(public readonly url: string) {
    this.audio = new Audio(url);
    window.addEventListener("touchstart", this.setupAudio);
    window.addEventListener("click", this.setupAudio);
  }

  private setupAudio = () => {
    this.audio.play();
    this.audio.pause();
    this.audio.currentTime = 0;
    this.ready = true;
    window.removeEventListener("touchstart", this.setupAudio);
    window.removeEventListener("click", this.setupAudio);
  };

  play() {
    if (this.ready) {
      this.audio.play();
    }
  }
}
